export default "__VITE_ASSET__Dhhyuu5H__"